export const splitForwardingEmail = forwardingEmail => (
  !forwardingEmail
    ? [null, null]
    : forwardingEmail.split('@')
)

export const joinForwardingEmail = (fEmailStart, fEmailEnd) => (
  !fEmailStart || !fEmailEnd
    ? ''
    : `${fEmailStart}@${fEmailEnd}`
)

export const splice = (arr, val) => {
  const ind = arr.indexOf(val)
  if (ind < 0) { return arr.slice() }

  const head = arr.slice(0, ind)
  const tail = arr.slice(ind + 1)

  return head.concat(tail).concat([val])
}



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/contact-info-validations/helpers.js